import { create } from 'zustand';
import { getAddressesApi } from '../../../api/api';

export const useAddressesStore = create((set, get) => ({
  data: [],
  isLoading: false,
  error: null,
  total: 0,

  fetchAddresses: async (page, limit, searchValue) => {
    set({ isLoading: true, error: null });

    await getAddressesApi(
      page,
      limit,
      searchValue,
      (data) => {
        set({ data: data?.items || [], total: data?.count, isLoading: false });
      },
      (err) => {
        set({ error: err, isLoading: false });
      }
    );
  },
}));
